<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-data-package`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M38 2c1.055 0 1.918.82 1.995 1.851L40 4v40c0 1.05-.816 1.918-1.85 1.995L38 46H10a2.003 2.003 0 01-1.995-1.851L8 44V4c0-1.05.815-1.918 1.85-1.994L10 2h28zm-2 32H12v8h24v-8zm-12 1a3 3 0 110 6 3 3 0 010-6zM36 6H12v24h24V6zm-3.597 5.624l.094.083 1.554 1.555a1 1 0 010 1.414l-7.496 7.495a1 1 0 01-1.414 0l-3.231-3.232-5.233 5.232a1 1 0 01-1.415 0l-1.555-1.556a1 1 0 01-.083-1.32l.083-.094 7.495-7.494a1 1 0 011.415 0l3.231 3.232 5.235-5.232a1 1 0 011.32-.083z"/></svg>
</template>
<script>

export default {
  name: 'IconDataPackage',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
